import script from "./HowItWorks.vue?vue&type=script&setup=true&lang=js"
export * from "./HowItWorks.vue?vue&type=script&setup=true&lang=js"

import "./HowItWorks.vue?vue&type=style&index=0&id=fb635580&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb635580"]])

export default __exports__